import { render } from "./collegeStudents.vue?vue&type=template&id=212197d8&scoped=true"
import script from "./collegeStudents.vue?vue&type=script&lang=js"
export * from "./collegeStudents.vue?vue&type=script&lang=js"

import "./collegeStudents.vue?vue&type=style&index=0&id=212197d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212197d8"]])

export default __exports__